function CalendarIcon({ ...rest }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' 
        width='19' 
        height='19' 
        viewBox='0 0 19 19' 
        fill='none'
        {...rest}
    >
      <path
        d='M13.3932 2.37496H16.5446C16.7535 2.37496 16.9539 2.45837 17.1017 2.60683C17.2494 2.7553 17.3324 2.95666 17.3324 3.16663V15.8333C17.3324 16.0433 17.2494 16.2446 17.1017 16.3931C16.9539 16.5416 16.7535 16.625 16.5446 16.625H2.36352C2.15457 16.625 1.95418 16.5416 1.80644 16.3931C1.65869 16.2446 1.57568 16.0433 1.57568 15.8333V3.16663C1.57568 2.95666 1.65869 2.7553 1.80644 2.60683C1.95418 2.45837 2.15457 2.37496 2.36352 2.37496H5.51487V0.791626H7.09054V2.37496H11.8176V0.791626H13.3932V2.37496ZM11.8176 3.95829H7.09054V5.54163H5.51487V3.95829H3.15136V7.12496H15.7567V3.95829H13.3932V5.54163H11.8176V3.95829ZM15.7567 8.70829H3.15136V15.0416H15.7567V8.70829Z'
        fill='#1D2B39'
      />
    </svg>
  );
}

export default CalendarIcon;
